module.exports = __webpack_public_path__ + "img/3-1.3b18ebee.svg";